import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "collect_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  key: 0,
  class: "collectList"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "name"
};
const _hoisted_7 = {
  class: "brief"
};
const _hoisted_8 = {
  key: 1,
  style: {
    "width": "40rem",
    "margin-top": "20%"
  },
  src: "https://www.mimodental.com/assets/imgData/img/new/que.png"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "我的收藏", -1))]), $setup.collectList.length != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.collectList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $setup.details(item.id)
    }, [_createElementVNode("img", {
      src: item.imgUrl,
      alt: ""
    }, null, 8, _hoisted_5), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(item.brief), 1), _cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "icon"
    }, [_createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/img/new/ysc.png",
      alt: ""
    })], -1))])], 8, _hoisted_4);
  }), 128))])) : (_openBlock(), _createElementBlock("img", _hoisted_8))]);
}